export type NotificationIdentifier = Readonly<{
    frontId: string;
    qmNum: string;
    maNum: string;
}>;

export const initialNotificationIdentifierState: NotificationIdentifier = {
    frontId: '',
    qmNum: '',
    maNum: '',
};
